import { galleryImages } from "../data/menuData";

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="bg-[#111111] border-b-2 border-black"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-10 lg:px-16 py-16 md:py-24">
        <div className="max-w-3xl mb-10 md:mb-14">
          <div className="inline-block brutal-border bg-[#FFB800] px-3 py-1 text-xs font-bold uppercase tracking-widest mb-4">
            Gallery
          </div>
          <h2 className="font-display text-5xl md:text-6xl lg:text-7xl uppercase leading-[0.95] text-white">
            Take a look and get <span className="text-[#FFB800]">hungry</span>.
          </h2>
        </div>

        <div
          className="grid gap-4 md:gap-5"
          style={{
            gridTemplateColumns: "repeat(6, 1fr)",
            gridAutoRows: "180px",
          }}
        >
          {galleryImages.map((img, idx) => {
            const layouts = [
              "col-span-3 row-span-2 md:col-span-3 md:row-span-2",
              "col-span-3 md:col-span-3 md:row-span-1",
              "col-span-3 md:col-span-3 md:row-span-1",
              "col-span-2 md:col-span-2 md:row-span-2",
              "col-span-2 md:col-span-2 md:row-span-1",
              "col-span-2 md:col-span-2 md:row-span-1",
            ];
            return (
              <div
                key={idx}
                data-testid={`gallery-img-${idx}`}
                className={`relative brutal-border overflow-hidden bg-[#FFB800] ${layouts[idx]}`}
              >
                <img
                  src={img.src}
                  alt={img.alt}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
